__webpack_require__.p = "https://cdn.dotpe.in/ds_assets/8b320b0123aaf8a41d35d48ce1647dc5ebf4f8c4/_next/";